import { z } from 'zod';
import { CustomErrorParams, CustomErrorType, DateTimeUtils, Validation } from '@mews/framework';
import { CalendarService, StructuredDate } from '@optimus-web/core';

export enum TrialBalanceFilterKeys {
    trialBalanceDate = 'trialBalanceDate',
}

export const createFilterSchema = ({
    minDate,
    maxDate,
    calendarService,
}: {
    minDate?: StructuredDate;
    maxDate?: StructuredDate;
    calendarService: CalendarService;
}) =>
    z.object({
        [TrialBalanceFilterKeys.trialBalanceDate]: z.nullable(
            Validation.Date.Iso.superRefine((value, ctx) => {
                const valueToStructuredDate = DateTimeUtils.dateIsoStringToStructureDate(value);
                if (
                    minDate &&
                    maxDate &&
                    !calendarService.isDateBetweenOrEqual(valueToStructuredDate, minDate, maxDate)
                ) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        params: { errorType: CustomErrorType.DateString } satisfies CustomErrorParams,
                        fatal: true,
                    });
                    return z.NEVER;
                }

                return value;
            })
        ),
    });

export type TrialBalanceFilterSchema = z.infer<ReturnType<typeof createFilterSchema>>;
